import { ProjectRegistryError } from "./types.js";
import { assertProjectAllowed, canReadProject, } from "./projectRegistry.js";
import { KNOWN_TOOL_IDS, PERMANENTLY_DENIED_TOOL_IDS, } from "./constants.js";
export const ALL_KNOWN_TOOL_IDS = new Set([
    ...KNOWN_TOOL_IDS,
    ...PERMANENTLY_DENIED_TOOL_IDS,
]);
export const SKILL_REGISTRY = [
    {
        skillId: "smart-print-audit",
        version: "0.1.0",
        title: "Smart Print Audit",
        description: "Read-only project audit for Smart Print Calculator.",
        instructionsPath: "docs/skills/smart-print-audit.md",
        projectScopes: ["smart-print"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "smart-ordering-audit",
        version: "0.1.0",
        title: "Smart Ordering Audit",
        description: "Read-only project audit for Smart Ordering.",
        instructionsPath: "docs/skills/smart-ordering-audit.md",
        projectScopes: ["smart-ordering"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "smart-salary-audit",
        version: "0.1.0",
        title: "Smart Salary Audit",
        description: "Read-only project audit for Smart Salary.",
        instructionsPath: "docs/skills/smart-salary-audit.md",
        projectScopes: ["smart-salary"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "drishti-kundali-audit",
        version: "0.1.0",
        title: "Drishti Kundali Audit",
        description: "Read-only project audit for Drishti Kundali.",
        instructionsPath: "docs/skills/drishti-kundali-audit.md",
        projectScopes: ["drishti-kundali"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "anoopam-website-audit",
        version: "0.1.0",
        title: "Anoopam Press Website Audit",
        description: "Read-only project audit for Anoopam Press Website.",
        instructionsPath: "docs/skills/anoopam-website-audit.md",
        projectScopes: ["anoopam-press-website"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "stylus-study-audit",
        version: "0.1.0",
        title: "Stylus Study Audit",
        description: "Read-only project audit for Stylus Education.",
        instructionsPath: "docs/skills/stylus-study-audit.md",
        projectScopes: ["stylus-education"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "anshika-api-audit",
        version: "0.1.0",
        title: "Anshika API Audit",
        description: "Read-only project audit for Anshika API.",
        instructionsPath: "docs/skills/anshika-api-audit.md",
        projectScopes: ["anshika-api"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "anshika-builder-audit",
        version: "0.1.0",
        title: "Anshika Website Maker Audit",
        description: "Read-only project audit for Anshika Website Maker.",
        instructionsPath: "docs/skills/anshika-builder-audit.md",
        projectScopes: ["anshika-website-maker"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "arcreel-public-audit",
        version: "0.1.0",
        title: "ArcReel Public Audit",
        description: "Read-only public project audit for ArcReel.",
        instructionsPath: "docs/skills/arcreel-public-audit.md",
        projectScopes: ["arcreel"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "low",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "dify-workflow-audit",
        version: "0.1.0",
        title: "Dify AnoopamPress Workflow Audit",
        description: "Read-only workflow audit for Dify AnoopamPress.",
        instructionsPath: "docs/skills/dify-workflow-audit.md",
        projectScopes: ["dify-anoopampress"],
        allowedTools: [
            "file_read",
            "file_list",
            "grep",
            "package_json_read",
            "knowledge_lookup",
            "git_status",
            "git_log",
            "git_branch",
            "mcp",
        ],
        deniedTools: [
            "file_write",
            "file_delete",
            "git_commit",
            "git_push",
            "shell",
            "deploy",
            "payment",
            "send_message",
            "database_write",
        ],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: {
            type: "object",
            properties: { projectId: { type: "string" }, query: { type: "string" } },
            required: ["projectId"],
        },
        outputSchema: {
            type: "object",
            properties: {
                hindiReport: { type: "string" },
                citations: { type: "array", items: { type: "string" } },
                limitations: { type: "array", items: { type: "string" } },
            },
            required: ["hindiReport", "citations", "limitations"],
        },
        status: "active",
    },
    {
        skillId: "reverse-api-security",
        version: "0.1.0",
        title: "Reverse API Security Assessment",
        description: "Imported, read-only API security assessment methodology for authorized REST, GraphQL, WebSocket, and SOAP targets.",
        instructionsPath: "docs/skills/reverse-security/api-security/SKILL.md",
        projectScopes: ["smart-ordering", "smart-salary", "drishti-kundali", "anoopam-press-website", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-code-audit",
        version: "0.1.0",
        title: "Reverse Code Audit",
        description: "Imported, read-only source-code security review methodology for authorized repositories.",
        instructionsPath: "docs/skills/reverse-security/code-audit/SKILL.md",
        projectScopes: ["smart-print", "smart-ordering", "smart-salary", "drishti-kundali", "anoopam-press-website", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-supply-chain-security",
        version: "0.1.0",
        title: "Reverse Supply Chain Security",
        description: "Imported, read-only supply-chain security assessment methodology for SBOM, SCA, CI/CD, and dependency provenance review.",
        instructionsPath: "docs/skills/reverse-security/supply-chain-security/SKILL.md",
        projectScopes: ["smart-print", "smart-ordering", "smart-salary", "drishti-kundali", "anoopam-press-website", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-email-security",
        version: "0.1.0",
        title: "Reverse Email Security",
        description: "Imported, read-only email security and phishing analysis methodology for authorized email review and tenant policy analysis.",
        instructionsPath: "docs/skills/reverse-security/email-security/SKILL.md",
        projectScopes: ["smart-ordering", "smart-salary", "drishti-kundali", "anoopam-press-website", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "medium",
        defaultMode: "read_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-cloud-k8s",
        version: "0.1.0",
        title: "Reverse Cloud and Kubernetes Security",
        description: "Imported, propose-only cloud, container, and Kubernetes security assessment methodology.",
        instructionsPath: "docs/skills/reverse-security/cloud-k8s/SKILL.md",
        projectScopes: ["anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "high",
        defaultMode: "propose_only",
        approvalRequired: true,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-database-security",
        version: "0.1.0",
        title: "Reverse Database Security",
        description: "Imported, propose-only database security assessment methodology for authorized configuration and schema review.",
        instructionsPath: "docs/skills/reverse-security/database-security/SKILL.md",
        projectScopes: ["smart-ordering", "smart-salary", "drishti-kundali", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "high",
        defaultMode: "propose_only",
        approvalRequired: true,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: true,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-docs-generator",
        version: "0.1.0",
        title: "Reverse Docs Generator",
        description: "Imported, propose-only documentation drafting assistant. Returns proposed markdown content only; no files are written.",
        instructionsPath: "docs/skills/reverse-security/docs-generator/SKILL.md",
        projectScopes: ["smart-print", "smart-ordering", "smart-salary", "drishti-kundali", "anoopam-press-website", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "low",
        defaultMode: "propose_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: false,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
    {
        skillId: "reverse-diagram-generator",
        version: "0.1.0",
        title: "Reverse Diagram Generator",
        description: "Imported, propose-only diagram source generator. Returns Mermaid, DOT, or PlantUML source; no rendering or file writes.",
        instructionsPath: "docs/skills/reverse-security/diagram-generator/SKILL.md",
        projectScopes: ["smart-print", "smart-ordering", "smart-salary", "drishti-kundali", "anoopam-press-website", "anshika-api", "anshika-website-maker"],
        allowedTools: ["file_read", "file_list", "grep", "package_json_read", "knowledge_lookup", "git_status", "git_log", "git_branch", "mcp"],
        deniedTools: ["file_write", "file_delete", "git_commit", "git_push", "shell", "deploy", "payment", "send_message", "database_write"],
        risk: "low",
        defaultMode: "propose_only",
        approvalRequired: false,
        maxCost: 0,
        maxDuration: 30000,
        evidenceRequired: true,
        rollbackRequired: false,
        inputSchema: { type: "object", properties: { projectId: { type: "string" }, query: { type: "string" } }, required: ["projectId"] },
        outputSchema: { type: "object", properties: { hindiReport: { type: "string" }, citations: { type: "array", items: { type: "string" } }, limitations: { type: "array", items: { type: "string" } } }, required: ["hindiReport", "citations", "limitations"] },
        status: "active",
    },
];
export function getSkillById(skillId) {
    return SKILL_REGISTRY.find((s) => s.skillId === skillId);
}
export function listSkillIds() {
    return SKILL_REGISTRY.map((s) => s.skillId);
}
export function getSkillsForProject(projectId) {
    return SKILL_REGISTRY.filter((s) => s.projectScopes.includes(projectId));
}
export function isKnownToolId(toolId) {
    return ALL_KNOWN_TOOL_IDS.has(toolId);
}
export function validateSkillRegistry(entries = SKILL_REGISTRY, projectIds) {
    const errors = [];
    const ids = new Set();
    const validModes = ["read_only", "propose_only", "approval_required", "denied"];
    const validRisks = ["low", "medium", "high", "critical"];
    const validStatuses = ["active", "disabled", "draft", "deprecated"];
    for (const skill of entries) {
        if (ids.has(skill.skillId)) {
            errors.push(`Duplicate skillId: ${skill.skillId}`);
        }
        ids.add(skill.skillId);
        if (!skill.skillId)
            errors.push("Skill missing skillId");
        if (!skill.title)
            errors.push(`Skill ${skill.skillId}: missing title`);
        if (!skill.description)
            errors.push(`Skill ${skill.skillId}: missing description`);
        if (!skill.instructionsPath)
            errors.push(`Skill ${skill.skillId}: missing instructionsPath`);
        if (!skill.version)
            errors.push(`Skill ${skill.skillId}: missing version`);
        if (!/^[\d.]+(?:[-+.]?[\w]+)*$/.test(skill.version)) {
            errors.push(`Skill ${skill.skillId}: version format invalid`);
        }
        if (!Array.isArray(skill.projectScopes) || skill.projectScopes.length === 0) {
            errors.push(`Skill ${skill.skillId}: projectScopes must be a non-empty array`);
        }
        if (projectIds && projectIds.length > 0) {
            for (const scope of skill.projectScopes) {
                if (!projectIds.includes(scope)) {
                    errors.push(`Skill ${skill.skillId}: unknown project scope ${scope}`);
                }
            }
        }
        if (skill.instructionsPath.includes("..") || skill.instructionsPath.includes("://") || skill.instructionsPath.startsWith("/")) {
            errors.push(`Skill ${skill.skillId}: instructionsPath contains traversal or external reference`);
        }
        if (!skill.instructionsPath.endsWith(".md")) {
            errors.push(`Skill ${skill.skillId}: instructionsPath must end with .md`);
        }
        if (!validModes.includes(skill.defaultMode)) {
            errors.push(`Skill ${skill.skillId}: invalid defaultMode ${skill.defaultMode}`);
        }
        if (!validRisks.includes(skill.risk)) {
            errors.push(`Skill ${skill.skillId}: invalid risk ${skill.risk}`);
        }
        if (!validStatuses.includes(skill.status)) {
            errors.push(`Skill ${skill.skillId}: invalid status ${skill.status}`);
        }
        if (typeof skill.maxCost !== "number" || skill.maxCost < 0) {
            errors.push(`Skill ${skill.skillId}: maxCost must be a non-negative number`);
        }
        if (typeof skill.maxDuration !== "number" || skill.maxDuration <= 0) {
            errors.push(`Skill ${skill.skillId}: maxDuration must be a positive number`);
        }
        if (typeof skill.inputSchema !== "object" || skill.inputSchema === null || Array.isArray(skill.inputSchema)) {
            errors.push(`Skill ${skill.skillId}: inputSchema must be an object`);
        }
        if (typeof skill.outputSchema !== "object" || skill.outputSchema === null || Array.isArray(skill.outputSchema)) {
            errors.push(`Skill ${skill.skillId}: outputSchema must be an object`);
        }
        for (const tool of skill.allowedTools) {
            if (!isKnownToolId(tool)) {
                errors.push(`Skill ${skill.skillId}: unknown tool in allowedTools: ${tool}`);
            }
        }
        for (const tool of skill.deniedTools) {
            if (!isKnownToolId(tool)) {
                errors.push(`Skill ${skill.skillId}: unknown tool in deniedTools: ${tool}`);
            }
        }
        const overlap = skill.allowedTools.filter((t) => skill.deniedTools.includes(t));
        if (overlap.length > 0) {
            errors.push(`Skill ${skill.skillId}: tools both allowed and denied: ${overlap.join(", ")}`);
        }
    }
    return { valid: errors.length === 0, errors };
}
export function assertSkillAllowed(skillId, projectId, tenantId, ownerId) {
    const skill = getSkillById(skillId);
    if (!skill) {
        throw new ProjectRegistryError(`Unknown skill: ${skillId}`);
    }
    if (skill.status !== "active") {
        throw new ProjectRegistryError(`Skill ${skillId} is not active`);
    }
    const project = assertProjectAllowed(projectId, tenantId, ownerId, "read");
    if (!skill.projectScopes.includes(projectId)) {
        throw new ProjectRegistryError(`Skill ${skillId} is not scoped to project ${projectId}`);
    }
    if (skill.defaultMode === "denied") {
        throw new ProjectRegistryError(`Skill ${skillId} is denied by default`);
    }
    if (!canReadProject(project, tenantId, ownerId)) {
        throw new ProjectRegistryError(`Project ${projectId} read not allowed`);
    }
    return { skill, project };
}
export function redactSkillForExport(skill) {
    return {
        skillId: skill.skillId,
        version: skill.version,
        title: skill.title,
        description: skill.description,
        instructionsPath: skill.instructionsPath,
        projectScopes: skill.projectScopes,
        allowedTools: skill.allowedTools,
        deniedTools: skill.deniedTools,
        risk: skill.risk,
        defaultMode: skill.defaultMode,
        approvalRequired: skill.approvalRequired,
        maxCost: skill.maxCost,
        maxDuration: skill.maxDuration,
        evidenceRequired: skill.evidenceRequired,
        rollbackRequired: skill.rollbackRequired,
        inputSchema: skill.inputSchema,
        outputSchema: skill.outputSchema,
        status: skill.status,
    };
}
//# sourceMappingURL=skillRegistry.js.map